import React, { useState, useEffect } from "react";

// import { AgGridColumn, AgGridReact } from "./node_modules/ag-grid-react";
import { PostApi, GetApi } from "../../../js_assets/Network";
import { getParameterByName } from "../../../js_assets/getParameterByName";
import AppAdminContainer from "../AppAdminContainer";
import { useHistory } from "react-router-dom";
import "./style.css";
// import "./node_modules/ag-grid-community/dist/styles/ag-grid.css";
// import "./node_modules/ag-grid-community/dist/styles/ag-theme-alpine.css";
import moment from "moment";
const SubsCount = () => {
  const [gridApi, setGridApi] = useState(null);
  const [Admin_Info, setAdmin_Info] = useState(
    JSON.parse(localStorage.getItem("Admin_Info"))
  );

  const [rowData, setRowData] = useState([]);
  const [drowData, setDRowData] = useState([]);
  const [trowData, setTRowData] = useState([]);
  const [duplication, setDuplication] = useState(false);
  const [times, setTimes] = useState(false);

  const history = useHistory();
  const tables = () => {
    let path = `/Admin/tables`;
    history.push(path);
  };

  const charts = () => {
    let path = `/Admin/charts`;
    history.push(path);
  };
  return (
    <AppAdminContainer Title={"الاحصائيات"}>
      <div>
        <div
          style={{
            marginTop: "12%",
            alignItems: "center",
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
          }}
        >
          <div className="polaroid" onClick={charts}>
            <img
              className="imge"
              src={require("../../../../imge/chart.png")}
              width={"100%"}
            />
            <div className="container">
              <p>الرسوم البيانية</p>
            </div>
          </div>
          <div onClick={tables} className="polaroid">
            <img src={require("../../../../imge/table.png")} width={"100%"} />
            <div className="container">
              <p> الجداول التفصيلية </p>
            </div>
          </div>
        </div>
      </div>
    </AppAdminContainer>
  );
};

export default SubsCount;

{
  /* <div
            onClick={charts}
            style={{
              borderLeftStyle: "solid",
              borderWidth: 0.1,
              display: "flex",
              flexDirection: "column",
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
              opacity: 0.9,
            }}
          >
            <img className="imge" src={require("../../../../imge/chart.png")} />
            الرسوم البيانية
          </div>
          <div
            onClick={tables}
            style={{
              borderRightStyle: "solid",
              borderWidth: 0.1,
              display: "flex",
              flex: 1,
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              opacity: 0.8,
            }}
          >
            <img className="imge" src={require("../../../../imge/table.png")} />
            الجداول
          </div> */
}
